import { Box, Grid, Typography } from '@mui/material';
import { IAdmissionDATA } from '../../../rest/types';
import moment from 'moment';
import { imgUrl } from '../../../Helpers/utils/Constant';

function FirstPageForm({ admissionData }: { admissionData: IAdmissionDATA }) {
  return (
    <Box mt={4}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box mt={1.5}>
              <img
                src={'/logo.png'}
                alt='Atab Logo'
                loading='lazy'
                height='50px'
              />
            </Box>
            <Box>
              <Typography fontSize={15}>
                To <br />
                <span style={{ fontWeight: 'bold' }}>
                  The Secretary General
                </span>
                <br />
                Association of Travel Agents of Bangladesh (ATAB) <br />
                Sattara center (15th Floor) <br />
                30/A,Nayapaltan,VIP Road,Dhaka 1000,Bangladesh
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              {admissionData.user_member_representative_photo ? (
                <img
                  src={`${imgUrl}/${admissionData.user_member_representative_photo}`}
                  loading='lazy'
                  alt=''
                  width='150px'
                  height='150px'
                  style={{ border: '1px solid gray' }}
                />
              ) : (
                ''
              )}

              <img
                src={`${imgUrl}/${admissionData.company_owner_photo}`}
                loading='lazy'
                alt=''
                width='150px'
                height='150px'
                style={{ marginLeft: '10px', border: '1px solid gray' }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box mt={3}>
        <Typography fontSize={15}>
          Application date:{' '}
          {admissionData?.application_date &&
            moment(admissionData?.application_date).format('DD/MM/YYYY')}
        </Typography>
        <Typography fontSize={14}>
          <span style={{ fontWeight: 'bold' }}>Through:</span> Chairman of
          Secretary, Zonal Committee,{' '}
          <span style={{ fontWeight: 'bold' }}>
            Dhaka / Chittagong / sylhet
          </span>
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlineOffset: '5px',
            textDecorationThickness: '3px',
            fontSize: 17,
          }}
          pt={2}
          pb={1}
        >
          Subject: Application of Membership
        </Typography>
        <Typography textAlign={'justify'} fontSize={15}>
          Dear Sir, <br />I / We here by apply to become a member of Association
          of Travel Agents of Bangladesh (ATAB) and Undertake to abide by the
          memorandum, Articles of Association and conduct rules of ATAB along
          with the laws there under as are presently and may come in force from
          time to time.
        </Typography>
        <Typography my={1} fontSize={15}>
          Particulars of the Organization required of Membership has been given
          below :-
        </Typography>
      </Box>
      <Box mt={2}>
        <table className='member-info-print'>
          <tbody>
            <tr>
              <th style={{ borderRight: '1px solid gray' }}>1</th>
              <th className='table-head'>Name of the Organization</th>
              <td>{admissionData.member_company_name}</td>
            </tr>

            <tr>
              <th style={{ borderRight: '1px solid gray' }}>2</th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Full Address
              </th>
              <td>{admissionData.addressline1}</td>
            </tr>

            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th className='table-middle-head'>Zone</th>
              <td>{admissionData.zone_name}</td>
            </tr>
            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Mobile Number
              </th>
              <td>{admissionData.phone}</td>
              <th className='table-middle-head'>Fax</th>
              <td>None</td>
            </tr>

            <tr
              style={{
                border: '1px solid gray',
                borderCollapse: 'collapse',
                width: '100%',
              }}
            >
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Telephone Number
              </th>
              <td>{admissionData.cellphone}</td>
            </tr>
            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Email
              </th>
              <td>{admissionData.email}</td>
            </tr>
            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Website
              </th>
              <td>{admissionData.member_company_website}</td>
            </tr>
            <tr>
              <th style={{ borderRight: '1px solid gray' }}>3</th>
              <th style={{ textAlign: 'start' }} colSpan={3}>
                Particulars of the Owner/Owners
              </th>
            </tr>

            {admissionData?.multipleOwnerAndDesignation?.map(
              (sOwner, index) => {
                return (
                  <tr key={index}>
                    <th style={{ borderRight: '1px solid gray' }}>
                      {index === 0 && 'i'}
                      {index === 1 && 'ii'}
                      {index === 2 && 'iii'}
                    </th>
                    <th
                      style={{
                        textAlign: 'start',
                        borderRight: '1px solid gray',
                      }}
                    >
                      Name
                    </th>
                    <td>{sOwner.company_owner_name}</td>
                    <th className='table-middle-head'>Designation</th>
                    <td colSpan={5}>{sOwner.company_owner_designation}</td>
                  </tr>
                );
              }
            )}

            <tr>
              <th style={{ borderRight: '1px solid gray' }}>4</th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Permanent Address
              </th>
              <td>{admissionData.company_owner_address}</td>
              <th className='table-middle-head'>Mob No</th>
              <td colSpan={5}>{admissionData.company_owner_phone}</td>
            </tr>

            <tr>
              <th style={{ borderRight: '1px solid gray', width: '7%' }}>5</th>
              <th style={{ textAlign: 'start', width: '100%' }} colSpan={6}>
                Particulars of person ,Who will Represent his Organization in
                ATAB (if Other than Owner)
              </th>
            </tr>

            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Name
              </th>
              <td>{admissionData.user_member_representative_name}</td>
              <th className='table-middle-head'>Designation</th>
              <td>{admissionData.user_member_representative_designation}</td>
            </tr>

            <tr style={{ border: '1px solid gray' }}>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th className='table-head'>Full Address</th>
              <td>{admissionData.user_member_representative_full_address}</td>
            </tr>
            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Phone (Office)
              </th>
              <td>{admissionData.user_member_representative_phone}</td>
              <th className='table-middle-head'>Resident</th>
              <td>None</td>
            </tr>

            <tr style={{ border: '1px solid gray' }}>
              <th style={{ borderRight: '1px solid gray' }}>6</th>
              <th style={{ textAlign: 'start' }}>Status of Ownership</th>
            </tr>

            <tr>
              <th style={{ borderRight: '1px solid gray' }}></th>
              <th style={{ textAlign: 'start', borderRight: '1px solid gray' }}>
                Company/Incorporated
              </th>
              <td>
                {admissionData.company_ownership_status === 'Incorporator'
                  ? 'YES'
                  : 'N/A'}
              </td>
              <th className='table-middle-head'>Partnership</th>
              <td>
                {' '}
                {admissionData.company_ownership_status === 'Partnership'
                  ? 'YES'
                  : 'N/A'}
              </td>
              <th className='table-middle-head'>Proprietorship</th>
              <td>
                {admissionData.company_ownership_status === 'Proprietorship'
                  ? 'YES'
                  : 'N/A'}
              </td>
            </tr>
          </tbody>
        </table>

        <Box mt={2} mb={3}>
          <table className='member-info-print'>
            <tbody>
              <tr>
                <th style={{ borderRight: '1px solid gray' }}>7</th>
                <th className='table-head'>Date of Establishment</th>
                <td>
                  {moment(admissionData.member_company_stablished_date).format(
                    'DD/MM/YYYY'
                  )}
                </td>
              </tr>
              <tr>
                <th style={{ borderRight: '1px solid gray', width: '3.4%' }}>
                  8
                </th>
                <th style={{ textAlign: 'start', width: '30%' }}>
                  NID Information
                </th>
              </tr>
              <tr>
                <th style={{ borderRight: '1px solid gray' }}></th>
                <th
                  style={{ textAlign: 'start', borderRight: '1px solid gray' }}
                >
                  Owner
                </th>
                <td>{admissionData.company_owner_nid}</td>
                <th className='table-middle-head'>Representative</th>
                <td>{admissionData.user_member_representative_nid_no}</td>
              </tr>
            </tbody>
          </table>
        </Box>
      </Box>
    </Box>
  );
}

export default FirstPageForm;
